const track = document.querySelector('.carousel-trackk');
const items = document.querySelectorAll('.item');
const nextBtn = document.querySelector('.next');
const prevBtn = document.querySelector('.prev');

let index = 0;
let interval;

  function updateSlide() {
    track.style.transform = `translateX(-${index * 100}%)`;
  }

  function nextSlide() {
    index = (index + 1) % items.length; // loop
    updateSlide();
  }

  function prevSlide() {
    index = (index - 1 + items.length) % items.length; // loop
    updateSlide();
  }

  nextBtn.onclick = nextSlide;
  prevBtn.onclick = prevSlide;

  // 🔥 Autoplay
  function startAutoSlide() {
    interval = setInterval(nextSlide, 3000); // 3 sec
  }

  function stopAutoSlide() {
    clearInterval(interval);
  }

  startAutoSlide();

  // Pause on hover (optional but recommended)
  const carousel = document.querySelector('.carousel');
  carousel.addEventListener('mouseenter', stopAutoSlide);
  carousel.addEventListener('mouseleave', startAutoSlide);



  document.addEventListener("DOMContentLoaded", function () {

  const unitToggle = document.getElementById("unitToggle");

  if (!unitToggle) return;

  unitToggle.addEventListener("change", function () {

    const cells = document.querySelectorAll(
      "td[data-cm][data-inch]"
    );

    cells.forEach(function (cell) {

      if (unitToggle.checked) {
        // CM
        cell.textContent = cell.getAttribute("data-cm");
      } else {
        // Inches
        cell.textContent = cell.getAttribute("data-inch");
      }

    });

  });

})